import { getSettingValueAndAssign } from "@faire/help-center-utils/settings/getSetting";
import { ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915 } from "@faire/web-api--source/indigofair/settings/ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915";

export function getSettingRetailerExclusivityAgreements(): boolean {
  return getSettingValueAndAssign(
    ENABLE_EXCLUSIVITY_AGREEMENTS_FOR_RETAILERS_230915,
    false
  );
}
